// extracted by mini-css-extract-plugin
module.exports = {"TabBorder":"AnimatedTabs_TabBorder__3aifl","Tabs_inModal":"AnimatedTabs_Tabs_inModal__ApyrS","Tabs":"AnimatedTabs_Tabs__20bCw"};